export default __webpack_public_path__ + "static/media/circle-checked.a32aff46.svg";